import { gql } from '@src/lib/gql'

/** Let go of a thread this operator was working (V2-L17). Someone else's live claim stays put. */
export const RELEASE_CRM_THREAD = gql`
  mutation ReleaseCrmThread($input: ReleaseCrmThreadInput!) {
    releaseCrmThread(input: $input) {
      ownerUserId
      ownerDisplayName
      ownedByViewer
      claimExpiresAt
    }
  }
`
